import BaseProduct from './BaseProduct';
import { ProductId } from '../types';
import store, { getLayerOpacity } from '../state';
import { getTileUrl, getAvailableLenticularTimes, getClosestTimeStep, getModelCoordinates } from '../config';

export class LenticularLayer extends BaseProduct {
  public readonly id: ProductId = 'lenticular';
  private unsubscribeStore: (() => void) | null = null;
  private lastModel: string = '';
  private lastMode: string = '';

  protected onActivate(): void {
    this.refresh();
    this.lastModel = store.getState().selectedModels['lenticular'] || 'ecmwf';
    this.lastMode = store.getState().lenticularMode || 'cap';
    this.unsubscribeStore = store.subscribe((s) => {
      if (!this.active) return;
      const currentModel = s.selectedModels['lenticular'] || 'ecmwf';
      const currentMode = s.lenticularMode || 'cap';
      if (currentModel !== this.lastModel || currentMode !== this.lastMode) {
        this.lastModel = currentModel;
        this.lastMode = currentMode;
        this.refresh();
      }
    });
  }

  protected onDeactivate(): void {
    if (this.unsubscribeStore) {
      this.unsubscribeStore();
      this.unsubscribeStore = null;
    }
    this.layerManager.removeBufferedRasterLayer(this.id);
    this.lastModel = '';
    this.lastMode = '';
  }

  protected onTimeUpdate(_date: string, _hour: string): void {
    this.refresh();
  }

  public refresh() {
    if (!this.active) return;
    const state = store.getState();
    const manifest = state.manifest;
    if (!manifest) return;

    const opacity = getLayerOpacity(this.id, 1.0);
    const current = state.currentTimeStep;
    if (!current) return;

    const rawModel = state.selectedModels['lenticular'] || 'ensemble';
    const model = (rawModel === 'blend' || !rawModel) ? 'ensemble' : rawModel;

    const mode = state.lenticularMode || 'cap';

    const availableSteps = getAvailableLenticularTimes(manifest, model);
    const closestStep = getClosestTimeStep(current, availableSteps);
    if (!closestStep) return;

    const resolvedDateStr = closestStep.date;
    const resolvedHourStr = closestStep.hour.replace('Z', '');
    const hourParam = `${mode}_${resolvedDateStr}_Z${resolvedHourStr}`;

    const tiles = [
      getTileUrl(manifest, 'lenticular', model, resolvedDateStr, hourParam)
    ];

    this.layerManager.updateBufferedRasterLayer(this.id, tiles, opacity, undefined, 0, 5, 'linear', getModelCoordinates(manifest, 'lenticular', model));
  }
}
export default LenticularLayer;
